/**
 * Utility functions for formatting data
 */

/**
 * Format a numeric amount as currency
 * @param amount - Dollar amount (not cents)
 * @param currency - ISO 4217 currency code (default: 'AUD')
 * @returns Formatted currency string (e.g., "$55.00")
 */
export const formatCurrency = (amount: number, currency: string = 'AUD'): string => {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

/**
 * Format cents as currency
 * @param cents - Amount in cents
 * @param currency - ISO 4217 currency code (default: 'AUD')
 * @returns Formatted currency string (e.g., "$55.00")
 */
export const formatCents = (cents: number, currency: string = 'AUD'): string => {
  return formatCurrency(cents / 100, currency);
};

/**
 * Parse currency string to cents
 * @param currencyString - Formatted currency string (e.g., "$55.00")
 * @returns Amount in cents
 */
export const parseCurrencyToCents = (currencyString: string): number => {
  const cleanedString = currencyString.replace(/[^0-9.-]+/g, '');
  const amount = parseFloat(cleanedString);
  return Math.round(amount * 100);
};
